import React from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'reactstrap'
import Skeleton from '../UI/Skeleton'

class Question extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            collapse: false,
        }
        this.collapse = this.collapse.bind(this)
    }

    collapse(id) {
        this.setState({ collapse: !this.state.collapse })
        document.querySelector(`.circle-plus.id-${id}`).classList.toggle('opened')
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <div className="faq-item">
                            <div className="d-flex justify-content-between">
                                <div className="title md-font-size"><Skeleton /></div>
                                <div className="circle-plus closed">
                                    <div className="circle">
                                        <div className="horizontal"></div>
                                        <div className="vertical"></div>
                                    </div>
                                </div>
                            </div>
                            <Skeleton />
                            <div className="horizontal-whitespace my-10"></div>
                        </div>
                        :
                        <div className="faq-item">
                            <div onClick={() => this.collapse(this.props.id)} className="d-flex justify-content-between">
                                <div className="title md-font-size">{this.props.title}</div>
                                <div className={`circle-plus id-${this.props.id} closed`}>
                                    <div className="circle">
                                        <div className="horizontal"></div>
                                        <div className="vertical"></div>
                                    </div>
                                </div>
                            </div>
                            <Collapse isOpen={this.state.collapse}>
                                <div className="desc md-font-size" dangerouslySetInnerHTML={{ __html: this.props.content }}></div>
                            </Collapse>
                            <div className="horizontal-whitespace my-10"></div>
                        </div>
                }
            </React.Fragment>
        )
    }
}

Question.propTypes = {
    id: PropTypes.number,
    title: PropTypes.string,
    content: PropTypes.string,
    skeleton: PropTypes.bool,
}

export default Question



// WEBPACK FOOTER //
// ./src/components/Terms/Question.jsx